import { useMutation } from "@apollo/react-hooks";
import { Modal } from "@shopify/polaris";
import React, { useCallback, useRef } from "react";
import { MARK_AS_TASK_CONFIGURABLE } from "../../../graphql/mutations";
import { handleError } from "../../../helper";
import { useToastContext } from "../../shared/ToastContext";

export const MarkAsTaskConfigurable = (props) => {
  // Props
  const {
    open,
    toggleShowModal,
    refetch,
    toggleActive,
    onNotificationChange,
    task,
    toggleModalParent,
  } = props;

  // Ref
  const onCloseRef = useRef(null);

  // Context
  const { setFilter } = useToastContext();

  // Mutation
  const [markAsTaskConfigurable, { loading }] = useMutation(
    MARK_AS_TASK_CONFIGURABLE,
    {
      onError: (error) => {
        if (onNotificationChange) {
          onNotificationChange({
            message: handleError(error.toString()),
            isError: true,
          });
        }
      },
      onCompleted: () => {
        toggleShowModal();
        if (onNotificationChange) {
          onNotificationChange({
            message: `Mark as task configurable success.`,
            isError: false,
          });
        }
        if (toggleModalParent) {
          toggleModalParent();
        }

        // onClose parent modal
        onCloseRef.current && clearTimeout(onCloseRef.current);
        onCloseRef.current = setTimeout(() => {
          setFilter && setFilter((prev) => ({ ...prev }));
          refetch && refetch();
        }, 1000);
      },
    },
  );

  // Handle actions
  const handleSubmit = useCallback(() => {
    let id = task?.id;
    if (id) {
      onNotificationChange &&
        onNotificationChange({
          message: null,
          isError: false,
        });
      toggleActive && toggleActive();
      markAsTaskConfigurable({
        variables: {
          taskIDs: [id],
        },
      });
    }
  }, [task, markAsTaskConfigurable, onNotificationChange, toggleActive]);

  return (
    <Modal
      title="Mark as Configurable"
      open={open}
      onClose={toggleShowModal}
      sectioned
      secondaryActions={[{ content: "Cancel", onAction: toggleShowModal }]}
      primaryAction={{
        content: "Submit",
        onAction: handleSubmit,
        loading: loading,
      }}
    >
      <p>
        Are you sure want to mark this task to Artwork Configurable for order #{task.orderId}
      </p>
    </Modal>
  );
};
